import { ActionTypes } from 'modules/experiments/ducks/actionTypes';
import { actionTypes as ToastsActionTypes } from 'modules/toastContainer/actionTypes';
import { NavigateOptions } from 'react-router-dom-v5-compat';
import { MutatedExperimentVariant } from '../takeover/types';

export type Payload = Record<string, unknown>;

export type ExperimentsAction<T = Record<string, unknown>, P = Payload> = {
  type: ActionTypes | ToastsActionTypes;
  payload?: P;
} & T;

export type SharedRouterState = {
  experimentName: string;
};

export interface ExperimentNavigateOptions extends Omit<NavigateOptions, 'state'> {
  state: SharedRouterState;
}

export enum ExperimentAnalyticsLoadingState {
  PAGE = 'pageLoading',
  PERFORMANCE_TAB = 'performanceTabLoading',
  OVERVIEW_TAB = 'overviewTabLoading',
}

export enum ExperimentAnalyticsErrorState {
  PAGE = 'pageError',
  PERFORMANCE_TAB = 'performanceTabError',
  OVERVIEW_TAB = 'overviewTabError',
}

export type MutateVariantResponse =
  | {
      isSuccess: true;
      mutatedVariant: MutatedExperimentVariant;
    }
  | {
      isSuccess: false;
    };
